'use strict';

function getMarket(searchKey) {
    if (searchKey.startsWith('SEARCH_ID_BAP')) {
        return 'bap';
    }
    if (searchKey.startsWith('SEARCH_ID_REAL')) {
        return 'realestate';
    }
    if (searchKey.startsWith('SEARCH_ID_JOB')) {
        return 'job';
    }
    if (searchKey.startsWith('SEARCH_ID_COMMERCIAL')) {
        return 'realestate';
    }
    if (searchKey.startsWith('SEARCH_ID_COMPANY_SALE')) {
        return 'realestate';
    }
    if (searchKey.startsWith('SEARCH_ID_ESTATE_PROJECT')) {
        return 'realestate';
    }
    if (searchKey.startsWith('SEARCH_ID_BOAT')) {
        return 'boat';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_PARALLEL_IMPORT')) {
        return 'car';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_CARAVAN')) {
        return 'car';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_USED')) {
        return 'car';
    }
    if (searchKey.startsWith('SEARCH_ID_AGRICULTURE')) {
        return 'b2b';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_MOBILE_HOME')) {
        return 'car';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_')) {
        return 'b2b';
    }
    if (searchKey.startsWith('SEARCH_ID_MC')) {
        return 'mc';
    }
    if (searchKey.startsWith('SEARCH_ID_TRAVEL_FLIGHT')) {
        return 'reise';
    }
    throw new Error(`No market for ${searchKey}`);
}

function getSubPath(searchKey, where) {
    if (where === 'MARKET') {
        return 'browse.html';
    }
    if (searchKey.startsWith('SEARCH_ID_BAP')) {
        return 'forsale/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_REALESTATE_NEWBUILDINGS')) {
        return 'newbuildings/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_BOAT_RENT')) {
        return 'rent/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_BUS')) {
        return 'bus/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_VAN_ABROAD')) {
        return 'vanimport/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_BOAT_DOCK_WANTED')) {
        return 'dock/wanted/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_BOAT_PARTS_MOTOR_WANTED')) {
        return 'motor/wanted/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_TRUCK_ABROAD')) {
        return 'truckabroad/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_REALESTATE_HOMES')) {
        return 'homes/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_REALESTATE_PLANNEDPROJECT')) {
        return 'homes/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_REALESTATE_LETTINGS_WANTED')) {
        return 'wanted/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_REALESTATE_LETTINGS')) {
        return 'lettings/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_COMMERCIAL_PLOTS')) {
        return 'businessplots/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_BOAT_PARTS')) {
        return 'motor/parts/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_BOAT_DOCK')) {
        return 'dock/available/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_PARALLEL_IMPORT')) {
        return 'import/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_BOAT_USED_WANTED')) {
        return 'wanted/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_COMMERCIAL_SALE')) {
        return 'businesssale/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_REALESTATE_LEISURE_PLOTS')) {
        return 'leisureplots/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_REALESTATE_PLOTS')) {
        return 'plots/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_REALESTATE_ABROAD_HOMES')) {
        return 'abroad/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_REALESTATE_LEISURE_SALE')) {
        return 'leisuresale/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_COMMERCIAL_RENT')) {
        return 'businessrent/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_MOBILE_HOME')) {
        return 'mobilehome/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_CARAVAN')) {
        return 'caravan/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_VAN')) {
        return 'vanused/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_USED')) {
        return 'used/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_AGRICULTURE_THRESHING')) {
        return 'agriculturecombines/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_BOAT_MOTOR')) {
        return 'motor/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_BOAT_USED')) {
        return 'forsale/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_MC_SCOOTER')) {
        return 'scooter/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_MC_USED')) {
        return 'all/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_MC_ATV')) {
        return 'atv/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_MC_SNOWMOBILE')) {
        return 'snowmobile/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_JOB_PARTTIME')) {
        return 'fulltime/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_JOB_AGGREGATED')) {
        return 'fulltime/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_JOB_MANAGEMENT')) {
        return 'management/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_JOB_FULLTIME')) {
        return 'fulltime/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_BOAT_NEW')) {
        return 'forsale/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_AGRICULTURE_TRACTOR')) {
        return 'agriculturetractor/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_AGRICULTURE_TOOL')) {
        return 'agriculturetools/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_TRUCK')) {
        return 'truck/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_CAR_AGRI')) {
        return 'construction/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_COMPANY_SALE')) {
        return 'companyforsale/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_ESTATE_PROJECT')) {
        return 'newbuildings/search.html';
    }
    if (searchKey.startsWith('SEARCH_ID_TRAVEL_FLIGHT')) {
        return 'flybilletter/resultat';
    }
    throw new Error(`No path for ${searchKey}`);
}

function getPath(searchKey, where) {
    return `${getMarket(searchKey)}/${getSubPath(searchKey, where)}`;
}

module.exports = getPath;
